"use client";

import { c as _c } from "react/compiler-runtime";
import { refreshTprWorkflowProgress } from "@/configuration/groups/tpr/components/workflow-progress";
import { useInvalidateServerComponent } from "@/src/components/server/client-provider";
import { Button } from "@/src/components/shadcn/ui/button";
import { toast } from "@/src/hooks/use-toast";
import { useContinueAfterManualTprStepMutation, useLocalTaskUpdateMutation } from "@/src/lib/data-fetchers/tasks-fetchers";
import type { StepKey } from "@/src/lib/workflows/steps/types";
import { type Task, TaskStatus } from "@/src/models/task";
export function TprManualStepContinueButton(t0) {
  const $ = _c(11);
  const {
    task,
    stepKey
  } = t0;
  const continueMutation = useContinueAfterManualTprStepMutation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      invalidateOnSettled: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const localTaskUpdateMutation = useLocalTaskUpdateMutation(t1);
  const invalidateInstructions = useInvalidateServerComponent("getReferralInstructions");
  let t2;
  if ($[1] !== continueMutation || $[2] !== invalidateInstructions || $[3] !== localTaskUpdateMutation || $[4] !== stepKey || $[5] !== task) {
    t2 = async () => {
      ;
      try {
        await continueMutation.mutateAsync({
          taskId: task.id,
          stepKey
        });
        localTaskUpdateMutation.mutate({
          ...task,
          status: TaskStatus.PROCESSING
        });
        refreshTprWorkflowProgress(invalidateInstructions);
        toast({
          title: "Manual step confirmed",
          description: "The workflow is continuing with the remaining steps."
        });
      } catch (t3) {
        const error = t3;
        toast({
          title: "Unable to continue the workflow",
          description: error instanceof Error ? error.message : "Refresh the task and try again.",
          variant: "destructive"
        });
      }
    };
    $[1] = continueMutation;
    $[2] = invalidateInstructions;
    $[3] = localTaskUpdateMutation;
    $[4] = stepKey;
    $[5] = task;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleContinue = t2;
  const t3 = continueMutation.isPending || localTaskUpdateMutation.isPending;
  const t4 = continueMutation.isPending ? "Continuing..." : "Continue";
  let t5;
  if ($[7] !== handleContinue || $[8] !== t3 || $[9] !== t4) {
    t5 = <Button size="sm" onClick={handleContinue} disabled={t3}>{t4}</Button>;
    $[7] = handleContinue;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}